let isSearchModalOpen = false;

function initializeSearchModal() {
    const searchToggle = document.getElementById('search-modal-toggle');
    const searchModal = document.getElementById('main-menu-search-modal');
    const closeButton = searchModal?.querySelector('.close-search-modal-button');

    if (!searchToggle || !searchModal) return;
    
    searchToggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleSearchModal();
    });

    searchToggle.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleSearchModal();
        }
    });
    
    if (closeButton) {
        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            hideSearchModal();
            searchToggle.focus(); // Return focus to search button
        });

        closeButton.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                hideSearchModal();
                searchToggle.focus(); // Return focus to search button
            }
        });
    }

    document.addEventListener('click', (e) => {
        if (isSearchModalOpen && !searchModal.contains(e.target) && e.target !== searchToggle) {
            hideSearchModal();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isSearchModalOpen) {
            hideSearchModal();
        }
    });
}

function toggleSearchModal() {
    const searchToggle = document.getElementById('search-modal-toggle');
    const isPressed = searchToggle.getAttribute('aria-pressed') === 'true';
    
    if (isPressed) {
        hideSearchModal();
    } else {
        // Close any open submenus first (cross-module communication)
        if (window.closeAllSubmenus) {
            window.closeAllSubmenus();
        }
        if (window.closeMobileMenu) {
            window.closeMobileMenu();
        }
        showSearchModal();
    }
}

function showSearchModal() {
    const searchToggle = document.getElementById('search-modal-toggle');
    const searchModal = document.getElementById('main-menu-search-modal');
    const closeButton = searchModal?.querySelector('.close-search-modal-button');

    searchToggle.setAttribute('aria-pressed', 'true');
    searchModal.setAttribute('aria-expanded', 'true');
    searchModal.classList.add('open');
    searchToggle.classList.add('active');
    
    isSearchModalOpen = true;
    
    const searchInput = searchModal.querySelector('#main-search-input');
    if (searchInput) {
        setTimeout(() => searchInput.focus(), 100);
    }
}

function hideSearchModal() {
    const searchToggle = document.getElementById('search-modal-toggle');
    const searchModal = document.getElementById('main-menu-search-modal');

    if (!searchToggle || !searchModal) return;

    searchToggle.setAttribute('aria-pressed', 'false');
    searchModal.setAttribute('aria-expanded', 'false');
    searchToggle.classList.remove('active');
    
    isSearchModalOpen = false;
    
    searchModal.classList.add('closing');
    
    setTimeout(() => {
        searchModal.classList.remove('open');
        searchModal.classList.remove('closing');
    }, 400);
}

// Expose functions for cross-module communication
window.hideSearchModal = hideSearchModal;
window.isSearchModalOpen = () => isSearchModalOpen;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSearchModal);
} else {
    initializeSearchModal();
}
